/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import moduleECommerce from './eCommerce/moduleECommerce.js'

Vue.use(Vuex);

import moduleAuth from './auth/moduleAuth.js'

const vuexLocalStorage = new VuexPersistence({
  key: 'SBGOnlineStore',
  storage: window.localStorage,
  reducer: state => ({
    AppActiveUser: state.AppActiveUser,
    eCommerce: state.eCommerce
  })
});

export default new Vuex.Store({
  getters,
  state,
  mutations,
  actions,
  modules: {
    auth: moduleAuth,
    eCommerce: moduleECommerce
  },
  plugins: [vuexLocalStorage.plugin],
  strict: process.env.NODE_ENV !== 'production'
})
